import {BasicSymbol} from "../../symbols/BasicSymbol";
import {XwaysHoarder2} from "../../../XwaysHoarder2";
import {gsap} from "gsap";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";
import {NormalSymbol} from "../../symbols/NormalSymbol";


export class FreespinReelAnimHandler {

    public readonly TRASH_SYM_ORDER: string [][] = [
        ["M6", "L5"],
        ["M5", "L4"],
        ["M4", "L3"],
        ["M3", "L2"]
    ];

    private currentFsLevel: number = 0;
    private nextFsLevel: number = 0;


    constructor() {

    }

    public getTrashAnimation(currentLvl: number, reels: string [][]): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();


        const symbolsToTrash: string [][] = [];

        const tmpArr: string [] = [];


        symbolsToTrash.push(this.TRASH_SYM_ORDER[currentLvl]);
        tmpArr.push(this.TRASH_SYM_ORDER[currentLvl][0]);
        tmpArr.push(this.TRASH_SYM_ORDER[currentLvl][1]);


        if(currentLvl < 3) {
            tl.add(XwaysHoarder2.trashSymView.buildTrashSplashSequence(currentLvl), 0);
        }

        //nrOfLvlsToProgress;
        //debugger;
        const symTl: gsap.core.Timeline = gsap.timeline();
        let playRemoveSound: boolean = false;
        symbolsToTrash.forEach((symList) => {
            symList.forEach((trashSym) => {
                if (reels) {
                    reels.forEach((reel, rId) => {
                        reel.forEach((symName, sId) => {
                            if (trashSym === symName) {
                                const sym: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[rId].model.getVisibleSymbolAt(sId).positionable;

                                if (sym && (<NormalSymbol>sym).playThrashAnimation) {
                                    if(currentLvl < 3) {
                                        symTl.add((<NormalSymbol>sym).playThrashAnimation(), 0);
                                        playRemoveSound = true;
                                    }
                                }
                            }
                        });
                    });
                }
            });
        });
        tl.add(symTl, ">");

        tl.addLabel("postTrashAnim");
        if (currentLvl === 3) {
            tl.add(XwaysHoarder2.trashSymView.buildTrashSplashSequence(currentLvl));
        }


        tl.add(() => {
            if (currentLvl < 3 && playRemoveSound) {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SYMBOL_REMOVE_CROSS);
            }
        }, "<");

        return tl;
    }


}